import { fixedUi } from '@/i18n/fixedUi';
import React from 'react';
import { countBrandRows, flattenBrandRows } from '@/temu-platform/utils/temuBrandIp';

export default function ShopBrandIpPanel({
  loading,
  error,
  brands,
}) {
  const brandRows = flattenBrandRows(brands);
  const brandCount = countBrandRows(brands);

  return (
    <div className="tpo-shop-info__panel" data-testid="temu-brand-ip">
      {loading ? <p className="tpo-return-detail__empty">{fixedUi("正在查询品牌…")}</p> : null}
      {error ? <p className="tpo-shop-info__inline-error" role="alert">{error}</p> : null}

      {!loading && !error ? (
        <div className="tpo-shop-info__split-block">
          {brandCount === 0 ? (
            <p className="tpo-return-detail__empty">{fixedUi("暂无可用品牌，请同步店铺信息后查看")}</p>
          ) : (
            <div className="tpo-shop-info__table-wrap">
              <table className="tpo-shop-info__table">
                <thead>
                  <tr>
                    <th>{fixedUi("品牌 ID")}</th>
                    <th>{fixedUi("品牌名称")}</th>
                    <th>{fixedUi("注册序列号")}</th>
                  </tr>
                </thead>
                <tbody>
                  {brandRows.map((row) => (
                    <tr key={row.key}>
                      <td><code>{row.brandCode}</code></td>
                      <td>{row.brandName}</td>
                      <td>{row.regSerialCode || '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : null}
    </div>
  );
}
